import Close from '@streamlinehq/streamlinehq/img/streamline-light/interface-essential/form-validation/close.svg';
import Search from '@streamlinehq/streamlinehq/img/streamline-light/interface-essential/search/search.svg';
import { E2eTestElementId } from '@upright/test-ids/dom-elements';
import { slide as MenuSlide } from 'react-burger-menu';
import styled from 'styled-components';
import { fluidSpaceLg } from '../../../../utilities/fluid/fluid';
import { BouSvgIcon } from '../../../bou-svg-icon';
import { useSearchOpenContext } from '../../use-search-open-context';
import {
  BurgerIconWrap,
  CloseButtonWrap,
  ContentMain,
  ContentRoot,
  MenuRoot,
  MenuTitleLarge,
  MenuTitleWrapper,
} from '../shared-menus';
import { ExampleSearchesBlock } from './example-searches-block';
import { SearchBlock } from './search-block';

export function ExploreMenu() {
  const { mobileSearchMenuOpen, setMobileSearchMenuOpen } = useSearchOpenContext();
  const openMenu = () => {
    setMobileSearchMenuOpen(true);
  };
  const closeMenu = () => {
    setMobileSearchMenuOpen(false);
  };

  return (
    <MenuRoot>
      <MenuSlide
        // noTransition={true}
        width={'100%'}
        customBurgerIcon={
          <IconWrap data-testid={E2eTestElementId.MOBILE_SEARCH_LINK} onClick={openMenu}>
            <BouSvgIcon icon={<Search />} />
          </IconWrap>
        }
        isOpen={mobileSearchMenuOpen}
        onStateChange={(state: { isOpen: boolean | ((prevState: boolean) => boolean) }) => {
          setMobileSearchMenuOpen(state.isOpen);
        }}
        right
        noOverlay={true}
        className={'test'}
      >
        <ContentRoot>
          <ContentMain>
            <MenuTitleWrapper>
              <MenuTitleLarge>Search</MenuTitleLarge>
              <CloseButtonWrap onClick={closeMenu}>
                <BouSvgIcon icon={<Close />} />
              </CloseButtonWrap>
            </MenuTitleWrapper>

            <div style={{ marginTop: 30, marginBottom: 30 }}>
              <SearchBlock close={closeMenu} />
            </div>
            <ExampleSearchesBlock close={closeMenu} />
          </ContentMain>
        </ContentRoot>
      </MenuSlide>
    </MenuRoot>
  );
}

const IconWrap = styled(BurgerIconWrap)`
  ${fluidSpaceLg('font-size', 50)}
  margin-top: 0.15em;
`;
